import React, { Component } from 'react'
import prepareComponent from 'client/shared/decorators/prepare-component'
import { withI18n } from '@lingui/react'
import { I18n } from '@lingui/core'
import compose from 'lodash/fp/compose'

import HeaderBox from 'client/shared/boxes/header-box'
import Copyright from 'client/shared/blocks/copyright'
import Spacer from 'client/shared/blocks/spacer'

import Meta from 'client/shared/blocks/meta'
import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'

import { loadGiftsPlans } from 'client/bookmate/reducers/gifts-reducer'
import { RecaptchaNotice } from 'client/shared/blocks/recaptcha/recaptcha-notice'

type Props = {
  i18n: I18n
  location: Location
}

class GiftsPage extends Component<Props> {
  render() {
    const { i18n, location } = this.props

    return (
      <>
        <MetaTitle disableSuffix title={i18n.t`gifts.share_title`} />
        <MetaDescription description={i18n.t`gifts.share_description`} />
        <Meta
          content={`${ASSETS_PATH}sharing/gifts_new.png`}
          property="twitter:image"
        />
        <Meta
          content={`${ASSETS_PATH}sharing/gifts_new.png`}
          property="og:image"
        />
        <Meta content="summary_large_image" property="twitter:card" />
        <HeaderBox />
        <div
          className={`gifts_wrapper source${location?.pathname?.replaceAll(
            '/',
            '-',
          )}`}
        >
          {this.props.children}
          <Spacer size={56} />
          <Copyright centered />
          <RecaptchaNotice />
        </div>
      </>
    )
  }
}

const wrappers = compose(
  prepareComponent(
    async function ({ store }) {
      const { dispatch } = store
      await dispatch(loadGiftsPlans())
    },
    { userListener: true },
  ),
  withI18n({ update: true }),
)

export default wrappers(GiftsPage)
